import { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { Circular } from '@components/button/icon'

import { getAccountState } from '@/account/state'
import { getEventState, requestCarouselBanner } from '@/events/state'

import { LandingHomeProps } from '@/landing/template'

import englishContents from "./data-banner-carousel.json";

import styled from 'styled-components'
const Wrapper = styled.div`
  width: 100vw;
  left: 0vw;
  @media (max-width: 600px) {
    display: none;
  }
`
const Container = styled.div`
  position: relative;
  display: flex;
  width: 100vw;
  margin: 0;
  padding: 0;
  height: 30vw;
  /* border: 1px dashed black; */
  overflow-x: hidden;
  .carousel-controller {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 7vw;
    height: 7vw;
    top: 37.5%;
    border-radius: 50%;
    border: 1.25vw solid white;
    background: var(--bg-tertiary);
    z-index: 1;
    cursor: pointer;
  }
`
const Item = styled.img`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 80vw;
  z-index: 0;
  font-size: 36pt;
  color: white;
  visibility: hidden;
`
const Slide = styled.img`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 80vw;
  z-index: 0;
  font-size: 36pt;
  color: white;
`
const CLeft = styled.div`
  left: 4vw;
`
const CRight = styled.div`
  right: 4vw;
`

const Navigation = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2.2em;
`

const List = styled.ul`
  list-style: none;
  display: flex;
`
const Bullet = styled.li`
  border-radius: 50%;
  width: 16px;
  height: 16px;
  margin: 5px;
  background: #888;
  cursor: pointer;
  &.active {
    background: orange;
  }
`

const Social = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  // width: 200px;
  p {
    margin-right: 1em;
  }
  span {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    width: 52px;
    height: 52px;
    margin: 0.2em;
    background: #f6f6f6;
    border: 1px solid rgba(0, 0, 0, 0.24);
    box-sizing: border-box;
    box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.14);
    border-radius: 10px;
    img {
      width: 20px;
    }
  }
  span:hover {
    border: 2px solid var(--bg-primary);
  }
`

const lang = {
  id: 'indonesia',
  en: 'english',
  'en-SG': 'english'
}

function Carousel ({ language }: LandingHomeProps) {
  const dispatch = useDispatch()
  const { sellonToken } = useSelector(getAccountState)
  const { carouselBanner } = useSelector(getEventState)
  const { apikey, nationCode } = sellonToken

  const [contentData, setContentData] = useState([])
  const [pos, setPos] = useState(2)
  const [bulletPos, setBulletPos] = useState(2)
  const [prevPos, setPrev] = useState(2)
  const [transition, setTransition] = useState(0)
  const maxContent = carouselBanner.data
    .filter((content) => content.type_language === lang[language])
    .filter((content) => parseInt(content.is_active) > 0).length
  const handleLeft = () => {
    setTransition(1)
    setPrev(pos)
    setPos(pos - 1)
    if (bulletPos === 1) setBulletPos(maxContent)
    else {
      setBulletPos(bulletPos - 1)
    }
  }
  const handleRight = () => {
    setTransition(1)
    setPrev(pos)
    setPos(pos + 1)

    if (bulletPos === maxContent) setBulletPos(1)
    else {
      setBulletPos(bulletPos + 1)
    }
  }
  const handleBullet = (idx) => {
    setTransition(1)
    const id = contentData
      .map((data, key) => ({
        priority: parseInt(data.priority),
        idx: key
      }))
      .filter((data) => parseInt(data.priority) === idx)[0].idx
    setPos(id + 1)
    setPrev(pos)
    setBulletPos(idx)
  }
  useEffect(() => {
    // dispatch(requestCarouselBanner({ apikey, nation_code: nationCode }))
    dispatch(requestCarouselBanner())
  }, [])
  useEffect(() => {
    setContentData(
      carouselBanner.data
        .filter((content) => content.type_language === lang[language])
        .filter((content) => parseInt(content.is_active) > 0)
    )
  }, [carouselBanner.data])
  useEffect(() => {
    const handleTransition = setTimeout(() => {
      const sliders = [...contentData]
      setTransition(0)
      if (pos === prevPos) return
      else if (pos > prevPos) {
        const iteration = pos - prevPos
        for (let i = 0; i < iteration; i++) {
          const removedSlider = sliders.shift()
          sliders.push(removedSlider)
        }
      } else {
        const iteration = prevPos - pos
        for (let i = 0; i < iteration; i++) {
          const removedSlider = sliders.pop()
          sliders.unshift(removedSlider)
        }
      }
      setContentData(sliders)
      setPos(prevPos)
    }, 1000)
    return () => {
      // cleanup
      clearTimeout(handleTransition)
    }
  }, [pos])

  return (
    <Wrapper>
      <Container>
        {contentData.length > 0 &&
          contentData.map((slide, key) => (
            <Item
              key={key}
              className="slide"
              src={
                carouselBanner.data
                  .filter((content) => content.type_language === lang[language])
                  .filter((content) => parseInt(content.is_active) > 0)
                  .filter(
                    (resSLider) =>
                      parseInt(resSLider.priority) === parseInt(slide.priority)
                  ).length > 0 &&
                carouselBanner.data
                  .filter((content) => content.type_language === lang[language])
                  .filter((content) => parseInt(content.is_active) > 0)
                  .filter(
                    (resSLider) =>
                      parseInt(resSLider.priority) === parseInt(slide.priority)
                  )[0].url
              }
            />
          ))}
        {contentData.length > 0 &&
          contentData.map((slide, key) => (
            <Slide
              key={key}
              className="slide"
              src={
                carouselBanner.data
                  .filter((content) => content.type_language === lang[language])
                  .filter((content) => parseInt(content.is_active) > 0)
                  .filter(
                    (resSLider) =>
                      parseInt(resSLider.priority) === parseInt(slide.priority)
                  ).length > 0 &&
                carouselBanner.data
                  .filter((content) => content.type_language === lang[language])
                  .filter((content) => parseInt(content.is_active) > 0)
                  .filter(
                    (resSLider) =>
                      parseInt(resSLider.priority) === parseInt(slide.priority)
                  )[0].url
              }
              style={{
                transition: `${transition}s`,
                left: `${85 * (key - pos + 1) + 10}vw`
              }}
            />
          ))}
        <CLeft className="carousel-controller prev-button">
          <Circular
            color="#EEEEEE"
            colorHover="#FEC010"
            icon="/media/iconpack/arrow-left-orange.png"
            iconHover="/media/iconpack/arrow-left-white.png"
            onClick={handleLeft}
            size="100%"
          />
        </CLeft>
        <CRight className="carousel-controller next-button">
          <Circular
            color="#EEEEEE"
            colorHover="#FEC010"
            icon="/media/iconpack/arrow-right-orange.png"
            iconHover="/media/iconpack/arrow-right-white.png"
            onClick={handleRight}
            size="100%"
          />
        </CRight>
      </Container>
      <Navigation>
        <List>
          {carouselBanner.data
            .filter((content) => content.type_language === lang[language])
            .filter((content) => parseInt(content.is_active) > 0)
            .map((content, key) => (
              <Bullet
                key={key}
                className={
                  parseInt(content.priority) === bulletPos ? 'active' : ''
                }
                onClick={() => handleBullet(parseInt(content.priority))}
              />
            ))}
        </List>
        <Social>
          <p>FOLLOW US </p>
          <div style={{ display: 'flex' }}>
            <a
              href="https://api.whatsapp.com/send?phone=6588562024"
              target="_blank"
            >
              <span>
                <img src="/media/logo/whatsapp.png" alt="Community" />
              </span>
            </a>
            <a href="http://facebook.com/sellonsg" target="_blank">
              <span>
                <img src="/media/logo/facebook.png" alt="Community" />
              </span>
            </a>
            <a href="http://instagram.com/sellon_sg" target="_blank">
              <span>
                <img src="/media/logo/instagram.png" alt="Community" />
              </span>
            </a>
          </div>
        </Social>
      </Navigation>
    </Wrapper>
  )
}

export default Carousel
